import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { ElvisDSModule } from 'ngx-elvis-ds';

import { OverlayDialogPage } from './overlay-dialog.page';
import { GUIBaseModule } from '../../gui-base/gui-base.module';
import { GUIScoModule } from '../../gui-sco/gui-sco.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        GUIBaseModule,
        GUIScoModule,
        ElvisDSModule,
    ],
    declarations: [
        OverlayDialogPage
    ]
})
export class OverlayDialogPageModule {}
